import { Common } from '@factorin/domain';

import { createActionNamespace } from 'Modules/core/redux';

import { IError, ISaveItem } from './types';


const storageAction = createActionNamespace('storage');

export const storageActions = {
    initialize: storageAction<void>('INITIALIZE'),
    receive: storageAction.withPath<Common.Catalog>('RECEIVE'),
    receiveWithUpdate: storageAction.withPath<Common.Catalog>('RECEIVE_WITH_UPDATE'),
    setError: storageAction.withPath<IError>('SET_ERROR'),
    resetError: storageAction.withPath<string>('RESET_ERROR'),
    loadItem: storageAction.withPath<Common.ElementId>('LOAD_ITEM'),
    saveItem: storageAction.withPath<ISaveItem>('SAVE_ITEM'),
};
